/* eslint-disable */
import PageContext from '@bingads-webui-static-legacy/page-context';
import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import ko from 'knockout';
import ChangeBudgetViewModel from '@bingads-webui-static-legacy/bulk-edit/viewmodel/campaign/changeBudget';
import template from '@bingads-webui-static-legacy/bulk-edit/template/campaign/changeBudget.pug';
import ChangeBudgetModel from '@bingads-webui-static-legacy/bulk-edit/model/campaign/changeBudget';
import BaseView from '@bingads-webui-static-legacy/bulk-edit/view/bulkEditJob';
import numericActionTypes from '@bingads-webui-static-legacy/schema/bulkEdit/numericActionType';
import actions from '@bingads-webui-static-legacy/schema/bulkEdit/changeBudgetActions';
import decimalNumber from '@bingads-webui-component-legacy/humanize/decimal';
import filterHelper from '@bingads-webui-static-legacy/bulk-edit/view/filterHelper';
import budgetTypes from '@bingads-webui-static-legacy/schema/campaign/budgetTypes';
import helpDirective from '@bingads-webui-static-legacy/directive/help';
import * as Persistence from '@bingads-webui-component-legacy/ko-persistence/observable-localstorage';
import * as instrumentation from '@bingads-webui-campaign-legacy/instrumentation/index';
var i18n = window.globalLegacyI18n.get('module/extension/requirejs/i18n!global');
var selectedUnitPreferenceName = 'WebApp.CampaignUI.CampaignGrid.changeBudget.selectedUnit.user(' + PageContext.CurrentUser.Id + ')';
var formatBudget = function (rows) {
  if (rows) {
    _.each(rows, function (value) {
      value.Entity = _.find(value.EntityKey, function (item) {
        return item.Key === 'CampaignName';
      });
      value.data = [];
      value.data.push({
        value: value.Entity && value.Entity.Value ? value.Entity.Value : '',
        isHtml: false
      });
      if (value.Changes && value.Changes.length) {
        value.data.push({
          value: decimalNumber.fromFloatToString(value.Changes[0].OriginalValue, 2),
          isHtml: false
        });
        value.data.push({
          value: decimalNumber.fromFloatToString(value.Changes[0].NewValue, 2),
          isHtml: false
        });
      } else {
        value.data.push({
          value: '',
          isHtml: false
        });
        value.data.push({
          value: '',
          isHtml: false
        });
      }
    });
  }
  return rows;
};
var view = BaseView.extend({
  initialize: function (options) {
    var senario = instrumentation.default.bulkEditCampaignBudget.create();
    var activity = senario.bulkEditCampaignBudget.create();
    activity.start();
    options.activity = activity;
    BaseView.prototype.initialize.call(this, options);
    this.ko_model = new ChangeBudgetViewModel(this.model);
    this.template = template;
    Persistence.on(this.ko_model.selectedUnit, selectedUnitPreferenceName);
  },
  render: function () {
    BaseView.prototype.render.apply(this, arguments);
    helpDirective.run(this.$el);
    return this;
  },
  setAction: function () {
    var action = null;
    var selectedAction = this.ko_model.selectedAction();
    var limitValue = selectedAction !== actions.Set && this.ko_model.useLimitValue() ? decimalNumber.fromLocalToFloat(this.ko_model.limitValue()) : null;
    var budgetAmount = decimalNumber.fromLocalToFloat(this.ko_model.budgetValue());
    if (selectedAction === actions.Decrease) {
      budgetAmount *= -1;
    }
    var actionType = selectedAction === actions.Set ? numericActionTypes.setAmount : this.ko_model.selectedUnit() === 'percentage' ? numericActionTypes.changeByPercent : numericActionTypes.changeByAmount;
    action = {
      Actions: [{
        '@odata.type': '#Model.NumericAction',
        Property: 'Budget/Amount',
        ActionType: actionType,
        Value: budgetAmount,
        Limit: limitValue
      }]
    };
    this.model.set('BatchAction', action);
  },
  getIdFilter: function () {
    var filter = filterHelper.getIdFilter(this.grid, 'Campaign');
    return filter;
  },
  getProgressText: function () {
    return i18n.getString('BulkEdit_Campaigns_ProgressText');
  },
  getCustomFilter: function () {
    var value = this.ko_model.isDailyBudget() ? [budgetTypes.dailyAccelerated, budgetTypes.dailyStandard] : [budgetTypes.lifetimeBudgetStandard];
    return {
      FilterExpressions: [{
        SelectedColumn: 'BudgetType',
        SelectedOperator: 'Equal',
        Values: value
      }]
    };
  },
  formatErrors: function (errors) {
    return formatBudget(errors);
  },
  formatPreviewResults: function (results) {
    return formatBudget(results);
  }
});
export default view;

